const config = {
    apigateway : {
        url : 'https://apigateway.pangeatech.io/',
        recommendationsApi : 'api/web/recommendations/',
        userDetailsApi : 'api/web/details/',
        placeTypesGroupApi : 'api/web/placetypes',
        tripsApi : 'api/web/trips/',
    }
}

export default config;